import React from 'react';
import { Subscription } from '../core/_models';

interface Props {
  subscription: Subscription | null;
  show: boolean;
  isLoading: boolean;
  onHide: () => void;
  onConfirm: (id: string) => void;
}

export const SubscriptionSuspendModal: React.FC<Props> = ({ subscription, show, isLoading, onHide, onConfirm }) => {
  if (!show || !subscription) return null;

  return (
    <>
      <div className='modal fade show d-block' tabIndex={-1} role='dialog' aria-modal='true'>
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          <div className='modal-content bg-body'>
            <div className='modal-header border-bottom border-gray-200 dark:border-gray-700'>
              <h2 className='fw-bolder text-gray-900'>Suspender Assinatura</h2>
              <div className='btn btn-icon btn-sm btn-active-icon-primary' onClick={onHide}>
                <i className='bi bi-x fs-1'></i>
              </div>
            </div>

            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6'>
                <i className='bi bi-exclamation-triangle fs-2tx text-warning me-4'></i>
                <div className='d-flex flex-stack flex-grow-1'>
                  <div className='fw-bold'>
                    <h4 className='text-gray-900 fw-bolder'>Aviso</h4>
                    <div className='fs-6 text-gray-700'>
                      A suspensão paralisa a cobrança temporariamente, mas não cancela a assinatura. Você poderá reativá-la no futuro.
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex flex-column mb-8'>
                <label className='fs-6 fw-bold mb-2'>Assinatura Selecionada</label>
                <div className='d-flex flex-stack bg-light rounded p-4'>
                  <span className='fw-bolder text-gray-800'>{subscription.client?.user?.name || subscription.client?.nameResponsible || 'Desconhecido'}</span>
                  <span className='text-muted fw-bold'>ID: {subscription.code}</span>
                </div>
              </div>

              <div className='text-center pt-15'>
                <button type='reset' className='btn btn-light me-3' onClick={onHide}>
                  Cancelar
                </button>
                <button
                  type='button'
                  className='btn btn-warning'
                  onClick={() => onConfirm(subscription.id)}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      Aguarde... <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  ) : (
                    <span className='indicator-label'>Confirmar Suspensão</span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  );
};
